import { Tree as BaseTree } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
/**
 * 树形选择
 */
export default function Tree({ minWidth, width, style, ...props }) {
  return (
    <BaseTree
      className="tree"
      style={{ minWidth, width: minWidth ? 'auto' : width, ...style }}
      {...props}
    ></BaseTree>
  );
}

Tree.propTypes = {
  /** 下拉框宽度 */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** 最小宽度，做自适应 */
  minWidth: PropTypes.number
};

Tree.defaultProps = {
  width: '100%',
  minWidth: 0
};

// export default Tree;
